import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactInfoSection from "./ContactInfoSection";
import ContactForm from "../../components/ContactFrom/ContactForm";
import {
  CONTACT_EMAIL,
  CONTACT_MAP_EMBED,
  CONTACT_PHONE,
} from "../../config/contact";

// import background image
import contactBg from "../../images/bg/contact-bg02.png";

const ContactPage: React.FC = () => {
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Contact us" pagesub="Contact us" />
            <ContactInfoSection />
            <section className="contact">
              <div className="container">
                <div
                  className="xb-contact-wrap xb-border bg_img"
                  style={{
                    backgroundImage: `url(${contactBg})`,
                  }}
                >
                  <div className="xb-contact-form xb-main-contact xb-border">
                    <div className="form-heading text-center mb-30">
                      <h3 className="title">Ready to start your project?</h3>
                      <p className="sub-title clr-white">
                        Call {CONTACT_PHONE} or email  {CONTACT_EMAIL} — we&apos;ll respond promptly.
                      </p>
                    </div>

                    <ContactForm/>
                  </div>

                  {/* Google Map Embed */}
                  <div className="google-map">
                    <iframe
                      src={CONTACT_MAP_EMBED}
                      loading="lazy"
                      title="gmap"
                      referrerPolicy="no-referrer-when-downgrade"
                      style={{ width: "100%", height: "100%", border: 0 }}
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ContactPage;